import React, { useState } from "react";
import { useLoadScript } from "@react-google-maps/api";
import { useUserRole } from "../../../context/UserRoleContext";
import DashboardLayout from "../../../components/common/DashboardLayout";
import BarList from "../components/management/BarList";
import BarAdminList from "../components/management/BarAdminList";
import PendingInvites from "../components/management/PendingInvites";
import InviteAdminForm from "../components/management/InviteAdminForm";
import ArtistsByBar from "../components/management/ArtistsByBar";

const libraries = ["places"];

const Management = () => {
  const { userData, loading } = useUserRole();
  const [activeTab, setActiveTab] = useState("bars");

  const { isLoaded: isMapsLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  const tabs = [
    { id: "bars", label: "Bar Information", icon: "🏪" },
    { id: "admins", label: "Bar Admins", icon: "👥" },
    { id: "artists", label: "Artists", icon: "🎤" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "bars":
        return <BarList isMapsLoaded={isMapsLoaded} />;
      case "admins":
        return (
          <div className="management-content">
            <div className="management-section">
              {/* <div className="section-header">
                <h2 className="section-title">Bar Admins</h2>
                <p className="section-subtitle">
                  Manage bar administrators and send invitations
                </p>
              </div> */}

              <div className="management-grid">
                <div className="management-col-left">
                  <BarAdminList />
                </div>

                <div className="management-col-right">
                  <PendingInvites />
                  <InviteAdminForm />
                </div>
              </div>
            </div>
          </div>
        );
      case "artists":
        return (
          <div className="management-content">
            <div className="management-section">
              {/* <div className="section-header">
                <h2 className="section-title">Artists</h2>
                <p className="section-subtitle">
                  Manage artists associated with your bars
                </p>
              </div> */}

              <ArtistsByBar isMapsLoaded={isMapsLoaded} />
            </div>
          </div>
        );
      default:
        return <BarList />;
    }
  };

  return (
    <DashboardLayout>
      <div className="bar-owner-dashboard">
        {/* Tab Selector */}
        <div className="tab-selector">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="tab-content">{renderTabContent()}</div>
      </div>
    </DashboardLayout>
  );
};

export default Management;
